<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M50.288 64.872v3.75H43.76v7.103h-4.467V58.46h13.204v3.897H43.76v2.516h6.528zM31.4 75.725h4.468V58.46H31.4v17.266zM14.03 62.355V58.46h14.915v3.897h-5.236v13.37H19.24v-13.37h-5.212zm57.178 31.127H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.289-4.315-4.289H11.922V10.643c0-2.268 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.155 61.586c0 2.275-1.858 4.125-4.145 4.125zM56.481 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M45.777 28.58a2.406 2.406 0 0 0-1.87.69l-3.095 3.099-7.889-7.841a2.407 2.407 0 0 0-1.703-.716 2.405 2.405 0 0 0-1.726.859l-11.99 14.3a2.374 2.374 0 0 0 .303 3.357c.4.333.9.527 1.423.552h33.573a2.39 2.39 0 0 0 2.398-2.384c0-.515-.169-1.017-.48-1.43l-7.194-9.533a2.401 2.401 0 0 0-1.75-.954M43.21 14.279c2.65 0 4.797 2.134 4.797 4.767 0 2.632-2.148 4.766-4.796 4.766-2.65 0-4.796-2.134-4.796-4.766 0-2.633 2.147-4.767 4.796-4.767"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-tif',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
